var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox product-list-page" },
    [
      _c(
        "el-card",
        {
          staticClass: "box-card product-list-card",
          attrs: { "body-style": { padding: "0", height: "100%" } },
        },
        [
          _c(
            "div",
            { staticClass: "product-list-header" },
            [
              _vm.checkPermi(["admin:product:tabs:headers"])
                ? _c(
                    "el-tabs",
                    {
                      on: { "tab-click": _vm.seachList },
                      model: {
                        value: _vm.tableFrom.type,
                        callback: function ($$v) {
                          _vm.$set(_vm.tableFrom, "type", $$v)
                        },
                        expression: "tableFrom.type",
                      },
                    },
                    _vm._l(_vm.headeNum, function (item, index) {
                      return _c("el-tab-pane", {
                        key: index,
                        attrs: {
                          label: item.name + "(" + item.count + ")",
                          name: item.type.toString(),
                        },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "product-search-wrap" },
                [
                  _c(
                    "el-form",
                    {
                      staticClass: "product-search-form",
                      attrs: { inline: "", size: "small" },
                    },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品名称：" } },
                        [
                          _c("el-input", {
                            staticClass: "search-input-name",
                            attrs: {
                              placeholder: "名称/关键字",
                              size: "small",
                              clearable: "",
                            },
                            nativeOn: {
                              keyup: function ($event) {
                                if (
                                  !$event.type.indexOf("key") &&
                                  _vm._k(
                                    $event.keyCode,
                                    "enter",
                                    13,
                                    $event.key,
                                    "Enter"
                                  )
                                ) {
                                  return null
                                }
                                return _vm.seachList($event)
                              },
                            },
                            model: {
                              value: _vm.tableFrom.keywords,
                              callback: function ($$v) {
                                _vm.$set(_vm.tableFrom, "keywords", $$v)
                              },
                              expression: "tableFrom.keywords",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品分类：" } },
                        [
                          _c("el-cascader", {
                            staticClass: "search-input-cate",
                            attrs: {
                              options: _vm.merCateList,
                              props: _vm.props,
                              clearable: "",
                              size: "small",
                            },
                            model: {
                              value: _vm.tableFrom.cateId,
                              callback: function ($$v) {
                                _vm.$set(_vm.tableFrom, "cateId", $$v)
                              },
                              expression: "tableFrom.cateId",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { attrs: { label: "是否星标：" } },
                        [
                          _c(
                            "el-select",
                            {
                              staticClass: "search-input-star",
                              attrs: { placeholder: "全部", clearable: "" },
                              model: {
                                value: _vm.tableFrom.isAdminStar,
                                callback: function ($$v) {
                                  _vm.$set(_vm.tableFrom, "isAdminStar", $$v)
                                },
                                expression: "tableFrom.isAdminStar",
                              },
                            },
                            [
                              _c("el-option", {
                                attrs: { label: "是", value: "1" },
                              }),
                              _vm._v(" "),
                              _c("el-option", {
                                attrs: { label: "否", value: "0" },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        { staticClass: "search-actions" },
                        [
                          _c(
                            "el-button",
                            {
                              directives: [
                                {
                                  name: "hasPermi",
                                  rawName: "v-hasPermi",
                                  value: ["admin:product:list"],
                                  expression: "['admin:product:list']",
                                },
                              ],
                              attrs: {
                                type: "primary",
                                icon: "el-icon-search",
                                size: "small",
                              },
                              on: { click: _vm.seachList },
                            },
                            [_vm._v("搜索")]
                          ),
                          _vm._v(" "),
                          _c(
                            "el-button",
                            {
                              staticClass: "ResetSearch",
                              attrs: { size: "small" },
                              on: { click: _vm.reset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "product-toolbar" },
                [
                  _c(
                    "router-link",
                    {
                      attrs: { to: { path: _vm.createOrEditUrl + "/2" } },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.saveScrollPosition($event)
                        },
                      },
                    },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "hasPermi",
                              rawName: "v-hasPermi",
                              value: ["admin:product:save"],
                              expression: "['admin:product:save']",
                            },
                          ],
                          attrs: { size: "small", type: "primary" },
                        },
                        [_vm._v("新增")]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:product:up"],
                          expression: "['admin:product:up']",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "default",
                        disabled:
                          !_vm.multipleSelection.length ||
                          Number(_vm.tableFrom.type) > 2,
                      },
                      on: { click: _vm.batchPutOnShell },
                    },
                    [_vm._v("批量上架")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:product:down"],
                          expression: "['admin:product:down']",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "default",
                        disabled:
                          !_vm.multipleSelection.length ||
                          Number(_vm.tableFrom.type) > 2,
                      },
                      on: { click: _vm.batchOffShell },
                    },
                    [_vm._v("批量下架")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:product:update"],
                          expression: "['admin:product:update']",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "default",
                        disabled: !_vm.multipleSelection.length,
                      },
                      on: { click: _vm.openBatchCateDialog },
                    },
                    [_vm._v("批量修改分类")]
                  ),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:product:update"],
                          expression: "['admin:product:update']",
                        },
                      ],
                      attrs: {
                        size: "small",
                        type: "default",
                        disabled: !_vm.multipleSelection.length,
                      },
                      on: { click: _vm.openBatchInventoryDialog },
                    },
                    [_vm._v("批量改库存")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { ref: "tableWrap", staticClass: "product-list-table-wrap" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.listLoading,
                      expression: "listLoading",
                    },
                  ],
                  ref: "productTable",
                  staticClass: "product-data-table",
                  attrs: {
                    border: true,
                    data: _vm.tableData.data,
                    height: _vm.tableHeight,
                    size: "mini",
                    "row-key": "id",
                    "highlight-current-row": true,
                    "header-cell-style": {
                      fontWeight: "bold",
                      padding: "6px 0",
                      height: "36px",
                    },
                  },
                  on: {
                    "selection-change": _vm.handleSelectionChange,
                    "sort-change": _vm.handleSortChange,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "selection",
                      width: "48",
                      align: "center",
                      fixed: "left",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "商品名称",
                      prop: "storeName",
                      "min-width": "260",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "div",
                              { staticClass: "name-with-thumb" },
                              [
                                _c(
                                  "span",
                                  {
                                    staticClass: "name-text",
                                    attrs: { title: scope.row.storeName },
                                  },
                                  [_vm._v(_vm._s(scope.row.storeName))]
                                ),
                                _vm._v(" "),
                                scope.row.image
                                  ? _c("el-image", {
                                      staticClass: "name-thumb",
                                      attrs: {
                                        src: scope.row.image,
                                        "preview-src-list": [scope.row.image],
                                      },
                                    })
                                  : _vm._e(),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.customConfig.mallType == 1
                    ? _c("el-table-column", {
                        attrs: {
                          label: "关键字",
                          prop: "keyword",
                          "min-width": "200",
                          "show-overflow-tooltip": true,
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.customConfig.mallTyle == 2
                    ? _c("el-table-column", {
                        attrs: { label: "商品封面图", "min-width": "80" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "demo-image__preview" },
                                    [
                                      _c("el-image", {
                                        staticStyle: {
                                          width: "36px",
                                          height: "36px",
                                        },
                                        attrs: {
                                          src: scope.row.image,
                                          "preview-src-list": [scope.row.image],
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2331550732
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "售价",
                      "min-width": "100",
                      align: "center",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                staticClass: "price-cell",
                                attrs: {
                                  title: _vm.formatPriceText(scope.row),
                                },
                              },
                              [_vm._v(_vm._s(_vm.formatPriceText(scope.row)))]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _vm.bizType == 2
                    ? _c("el-table-column", {
                        attrs: {
                          label: "积分价格",
                          prop: "pointsPrice",
                          "min-width": "90",
                          align: "center",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(scope.row.pointsPrice) + "积分"
                                    ),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2028081590
                        ),
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sales",
                      label: "销量",
                      "min-width": "90",
                      align: "center",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "stock",
                      label: "库存",
                      "min-width": "90",
                      align: "center",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "sort",
                      label: "排序",
                      "min-width": "70",
                      align: "center",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "创建时间",
                      "min-width": "120",
                      align: "center",
                      sortable: "custom",
                      prop: "addTime",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm._f("formatDate")(scope.row.addTime))
                              ),
                            ]),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: { label: "状态", width: "88", fixed: "right" },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return _vm.checkPermi([
                              "admin:product:up",
                              "admin:product:down",
                            ])
                              ? [
                                  scope.row.storeName != "不装订"
                                    ? _c("el-switch", {
                                        attrs: {
                                          disabled:
                                            Number(_vm.tableFrom.type) > 2,
                                          "active-value": true,
                                          "inactive-value": false,
                                          "active-text": "上架",
                                          "inactive-text": "下架",
                                        },
                                        on: {
                                          change: function ($event) {
                                            return _vm.onchangeIsShow(scope.row)
                                          },
                                        },
                                        model: {
                                          value: scope.row.isShow,
                                          callback: function ($$v) {
                                            _vm.$set(scope.row, "isShow", $$v)
                                          },
                                          expression: "scope.row.isShow",
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              : undefined
                          },
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "后台星标",
                      width: "96",
                      fixed: "right",
                      prop: "isAdminStar",
                      sortable: "custom",
                      "sort-orders": ["ascending", "descending"],
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c("el-switch", {
                              attrs: {
                                "active-value": true,
                                "inactive-value": false,
                                "active-text": "是",
                                "inactive-text": "否",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onStar(scope.row)
                                },
                              },
                              model: {
                                value: scope.row.isAdminStar,
                                callback: function ($$v) {
                                  _vm.$set(scope.row, "isAdminStar", $$v)
                                },
                                expression: "scope.row.isAdminStar",
                              },
                            }),
                          ]
                        },
                      },
                    ]),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      label: "操作",
                      width: "248",
                      fixed: "right",
                      align: "center",
                      "class-name": "action-column",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            scope.row.storeName != "不装订"
                              ? _c(
                                  "div",
                                  { staticClass: "action-cell" },
                                  [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              _vm.detailUrl +
                                              "/" +
                                              _vm.tableFrom.type +
                                              "/" +
                                              scope.row.id +
                                              "/1",
                                          },
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.saveScrollPosition(
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: ["admin:product:info"],
                                                expression:
                                                  "['admin:product:info']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("详情")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              _vm.createOrEditUrl +
                                              "/" +
                                              _vm.tableFrom.type +
                                              "/" +
                                              scope.row.id,
                                          },
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.saveScrollPosition(
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: ["admin:product:update"],
                                                expression:
                                                  "['admin:product:update']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("编辑")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: {
                                            path:
                                              _vm.inventoryAdjustUrl +
                                              "/" +
                                              _vm.tableFrom.type +
                                              "/" +
                                              scope.row.id,
                                          },
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.saveScrollPosition(
                                              $event
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: ["admin:product:update"],
                                                expression:
                                                  "['admin:product:update']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                          },
                                          [_vm._v("库存修改")]
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.showLanguageBtn
                                      ? _c("multi-lang-product-maintain", {
                                          directives: [
                                            {
                                              name: "hasPermi",
                                              rawName: "v-hasPermi",
                                              value: ["admin:system:language"],
                                              expression:
                                                "['admin:system:language']",
                                            },
                                          ],
                                          staticClass: "action-lang-btn",
                                          attrs: {
                                            "product-id": scope.row.id,
                                            "page-biz-ids":
                                              _vm.currentPageBizIds,
                                            "page-data-version":
                                              _vm.i18nPageDataVersion,
                                          },
                                          on: { saved: _vm.getList },
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.tableFrom.type === "5"
                                      ? _c(
                                          "el-button",
                                          {
                                            directives: [
                                              {
                                                name: "hasPermi",
                                                rawName: "v-hasPermi",
                                                value: [
                                                  "admin:product:restore",
                                                ],
                                                expression:
                                                  "['admin:product:restore']",
                                              },
                                            ],
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleRestore(
                                                  scope.row.id,
                                                  scope.$index
                                                )
                                              },
                                            },
                                          },
                                          [_vm._v("恢复")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        directives: [
                                          {
                                            name: "hasPermi",
                                            rawName: "v-hasPermi",
                                            value: ["admin:product:delete"],
                                            expression:
                                              "['admin:product:delete']",
                                          },
                                        ],
                                        attrs: { type: "text", size: "mini" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(
                                              scope.row.id,
                                              _vm.tableFrom.type
                                            )
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.tableFrom.type === "5"
                                              ? "删除"
                                              : "加入回收站"
                                          )
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "product-list-pagination block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [10, 20, 40, 60],
                  "page-size": _vm.tableFrom.limit,
                  "current-page": _vm.tableFrom.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.pageChange,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("batch-inventory-adjust-dialog", {
        attrs: {
          visible: _vm.batchInventoryDialogVisible,
          products: _vm.batchInventoryProducts,
          "biz-type": _vm.bizType,
        },
        on: {
          "update:visible": function ($event) {
            _vm.batchInventoryDialogVisible = $event
          },
          success: _vm.onBatchInventorySuccess,
        },
      }),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "批量修改分类",
            visible: _vm.batchCateDialogVisible,
            width: "520px",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.batchCateDialogVisible = $event
            },
            closed: _vm.onBatchCateDialogClosed,
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "100px", size: "small" } },
            [
              _c("el-form-item", { attrs: { label: "已选商品" } }, [
                _c("span", [
                  _vm._v(_vm._s(_vm.multipleSelection.length) + " 件"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "所属分类", required: "" } },
                [
                  _c("el-cascader", {
                    staticClass: "selWidth",
                    attrs: {
                      options: _vm.merCateList,
                      props: _vm.batchCateProps,
                      clearable: "",
                      "show-all-levels": false,
                      placeholder: "请选择分类（与编辑商品一致）",
                    },
                    model: {
                      value: _vm.batchCatePath,
                      callback: function ($$v) {
                        _vm.batchCatePath = $$v
                      },
                      expression: "batchCatePath",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { size: "small" },
                  on: {
                    click: function ($event) {
                      _vm.batchCateDialogVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "small",
                    loading: _vm.batchCateSubmitting,
                  },
                  on: { click: _vm.submitBatchCate },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }